import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  width: 100%;
  height: calc(100% - 63px);
  &:focus {
    outline-width: 0;
    outline: none;
  }
`;